/**
 * Network Capture Service
 * Intercepts fetch requests and captures network errors
 * for bug report submission.
 */

const networkErrors = [];
const MAX_ERRORS = 50;

export function initNetworkCapture() {
  const originalFetch = window.fetch;

  window.fetch = async (...args) => {
    const startTime = Date.now();
    try {
      const response = await originalFetch(...args);
      if (!response.ok) {
        networkErrors.push({
          type: 'fetch',
          url: args[0],
          status: response.status,
          statusText: response.statusText,
          duration: Date.now() - startTime,
          timestamp: new Date().toISOString()
        });
        trimErrors();
      }
      return response;
    } catch (error) {
      networkErrors.push({
        type: 'fetch',
        url: args[0],
        error: error.message,
        duration: Date.now() - startTime,
        timestamp: new Date().toISOString()
      });
      trimErrors();
      throw error;
    }
  };
}

function trimErrors() {
  while (networkErrors.length > MAX_ERRORS) {
    networkErrors.shift();
  }
}

export function getNetworkErrors() {
  return [...networkErrors];
}
